import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  backTo: string;
  backLabel?: string;
  actions?: ReactNode;
}

export default function PageHeader({
  title,
  subtitle,
  backTo,
  backLabel = 'رجوع',
  actions,
}: PageHeaderProps) {
  const navigate = useNavigate();

  return (
    <div className="mb-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-start gap-3">
        <button
          type="button"
          onClick={() => navigate(backTo)}
          aria-label={backLabel}
          className="flex h-10 w-10 shrink-0 items-center justify-center rounded-btn border border-background-200 bg-white text-foreground-600 transition-colors hover:bg-background-50 hover:text-foreground-900"
        >
          <i className="ri-arrow-right-line text-lg" aria-hidden="true"></i>
        </button>
        <div className="min-w-0">
          <h2 className="font-bold text-[18px] text-foreground-950">{title}</h2>
          {subtitle && <p className="mt-1 text-[12px] text-foreground-400">{subtitle}</p>}
        </div>
      </div>
      {actions && <div className="flex shrink-0 items-center gap-3">{actions}</div>}
    </div>
  );
}